/* eslint-disable no-undef,one-var,new-cap */
import { check } from '@/assets/js/checkUpdate'
import { openUrl } from './util.js'

// import router from '@/router/index'

function checkArguments () {
  let args = plus.runtime.arguments
  if (args) {
    args = decodeURIComponent(args)
    args = args.substr(7, args.length - 1)
    if (args) {
      args = JSON.parse(args)
      if (typeof (args) === 'object') {
        openUrl(args)
      }
    }
    // 处理args参数，如打开新页面等
  }
}

// 处理后台恢复
document.addEventListener('newintent', function () {
  checkArguments()
})

document.addEventListener('plusready', function () {
  // 自己写的压缩视频接口
  let _BARCODE = 'compressVideo'
  let B = window.plus.bridge
  let compressVideo = {

    compression: function (path, successCallback) {
      var success = typeof successCallback !== 'function' ? null : function (args) {
          successCallback(args)
        },
        callbackID = B.callbackId(success, null)
      return B.exec(_BARCODE, 'compression', [path, callbackID])
    }
  }

  let RecordVideoIos = function (options) {
    this.options = this.extend(
      {
        setResolutionMode: '540p', // 录制 设置录制分辨率，目前支持360p，480p，540p，720p
        setRatioMode: '1/1', // 录制 设置视频比例，目前支持1/1 ,3/4, 9/16
        setRecordMode: 'AUTO', // 录制 设置录制模式，目前支持按录:PRESS，点录:TOUCH和混合模式:AUTO
        setBeautyLevel: 80, // 录制 设置美颜度,1-100,比率
        setBeautyStatus: true, // 录制 设置美颜开关
        setCameraType: 'BACK',  // 录制 设置前后置摄像头, 后：BACK ，前：FRONT
        setFlashType: 'NO',  // 录制 设置闪光灯模式，开：NO, 关：OFF, 自动：AUTO
        setNeedClip: true, // 录制 设置是否需要支持片段录制
        setMaxDuration: 15, // 录制 设置最大录制时长 单位秒
        setMinDuration: 2, // 录制 设置最小录制时长 单位秒
        setVideoQuality: 'HD', // 录制设置视频质量 4个级别, 低：LD ,中：SD ，高：HD ，极高：SSD
        setGop: 125, // 设置关键帧间隔，建议：1-300之间
        setMinVideoDuration: 5, // 裁剪 设置过滤的视频最小长度 单位秒
        setMaxVideoDuration: 15, // 裁剪 设置过滤的视频最大长度 单位秒
        setMinCropDuration: 2,  // 裁剪 设置视频最小裁剪时间 单位毫秒
        setFrameRate: 25, // 裁剪 设置帧率
        setNeedRecord: false, // 设置是否需要开放录制入口,即选择视频的页面，多出一个录制按钮
        setResulutionMode: '540p', // 设置裁剪分辨率，目前支持360p，480p，540p，720p
        setCropMode: 'cpu' // 设置裁剪方式，是否使用gpu进行裁剪，不设置则默认使用cpu来裁剪
      }, options)
    this.init()
  }

  RecordVideoIos.prototype = {
    init: function () {
      this.event()
    },
    event: function () {
    },
    extend: function (obj, obj2) {
      for (var k in obj2) {
        obj[k] = obj2[k]
      }
      return obj
    },
    open: function (fn) {
      let B = window.plus.bridge
      let success = typeof fn !== 'function' ? null : function (args) {
        fn(args)
      }
      let callbackID = B.callbackId(success, null)
      return B.exec('RecordVideo', 'record', [JSON.stringify(this.options), callbackID])
    }
  }
  // let RecordVideoIos = {
  //   open: function (option, successCallback) {
  //     var success = typeof successCallback !== 'function' ? null : function (args) {
  //         successCallback(args)
  //       },
  //       callbackID = B.callbackId(success, null)
  //     return B.exec('RecordVideo', 'record', [option, callbackID])
  //   }
  // }
  // 始终保持横屏
  plus.screen.lockOrientation('portrait-primary')

  // 推送
  plus.push.addEventListener('click', function (msg) {
    if (msg.payload && msg.payload.url) {
      openUrl(msg.payload)
    }
    plus.push.remove(msg)
  }, false)

  // plus.push.addEventListener('receive', function (msg) {
  //   alert(JSON.stringify(msg))
  //   if (msg.aps) {
  //     alert('接收到在线APNS消息')
  //   } else {
  //     alert('接收到在线透传消息')
  //   }
  // })

  // 视频录制插件
// eslint-disable-next-line no-use-before-define
  let RecordVideo = function (options) {
    // 参数合并 ,这里一共有19个参数，视频默认保存在相册下
    this.options = this.extend(
      {
        setResolutionMode: '540p', // 录制 设置录制分辨率，目前支持360p，480p，540p，720p
        setRatioMode: '9/16', // 录制 设置视频比例，目前支持1/1 ,3/4, 9/16
        setRecordMode: 'AUTO', // 录制 设置录制模式，目前支持按录:PRESS，点录:TOUCH和混合模式:AUTO
        setBeautyLevel: 80, // 录制 设置美颜度,1-100,比率
        setBeautyStatus: true, // 录制 设置美颜开关
        setCameraType: 'BACK',  // 录制 设置前后置摄像头, 后：BACK ，前：FRONT
        setFlashType: 'NO',  // 录制 设置闪光灯模式，开：NO, 关：OFF, 自动：AUTO
        setNeedClip: true, // 录制 设置是否需要支持片段录制
        setMaxDuration: 15, // 录制 设置最大录制时长 单位秒
        setMinDuration: 2, // 录制 设置最小录制时长 单位秒
        setVideoQuality: 'HD', // 录制设置视频质量 4个级别, 低：LD ,中：SD ，高：HD ，极高：SSD
        setGop: 125, // 设置关键帧间隔，建议：1-300之间
        setMinVideoDuration: 5, // 裁剪 设置过滤的视频最小长度 单位秒
        setMaxVideoDuration: 15, // 裁剪 设置过滤的视频最大长度 单位秒
        setMinCropDuration: 2,  // 裁剪 设置视频最小裁剪时间 单位毫秒
        setFrameRate: 25, // 裁剪 设置帧率
        setNeedRecord: false, // 设置是否需要开放录制入口,即选择视频的页面，多出一个录制按钮
        setResulutionMode: '540p', // 设置裁剪分辨率，目前支持360p，480p，540p，720p
        setCropMode: 'cpu' // 设置裁剪方式，是否使用gpu进行裁剪，不设置则默认使用cpu来裁剪
      }, options)
    this.init()
  }
  RecordVideo.prototype = {
    init: function () {
      this.event()
    },
    event: function () {
    },
    extend: function (obj, obj2) {
      for (var k in obj2) {
        obj[k] = obj2[k]
      }
      return obj
    },
    open: function (fn) {
      var main = window.plus.android.runtimeMainActivity()
      var Intent = window.plus.android.importClass('android.content.Intent')
      var intent = new Intent(main.getIntent())
      intent.setClassName(main, 'com.xyzy.dd.plug.RecordVideo')
      intent.setFlags(Intent.FLAG_ACTIVITY_CLEAR_TOP)
      intent.putExtra('datajson', JSON.stringify(this.options))
      main.onActivityResult = function (requestCode, resultCode, data) {
        if (requestCode !== 1001) {
          return
        }
        window.plus.android.importClass(data)
        var bundle = data.getExtras()
        window.plus.android.importClass(bundle)
        var _resultCode = bundle.getString('resultCode')
        var json = {}
        json.code = _resultCode
        if (_resultCode === '000000') {
          json.path = bundle.getString('path')
        }
        fn(json)
      }
      main.startActivityForResult(intent, 1001)
    }
  }

  const option = {
    setResolutionMode: '720p', // 录制 设置录制分辨率，目前支持360p，480p，540p，720p
    setRatioMode: '1/1', // 录制 设置视频比例，目前支持1/1 ,3/4, 9/16
    setRecordMode: 'AUTO', // 录制 设置录制模式，目前支持按录:PRESS，点录:TOUCH和混合模式:AUTO
    setBeautyLevel: 60, // 录制 设置美颜度,1-100,比率
    setBeautyStatus: true, // 录制 设置美颜开关
    setCameraType: 'BACK',  // 录制 设置前后置摄像头, 后：BACK ，前：FRONT
    setFlashType: 'OFF',  // 录制 设置闪光灯模式，开：NO, 关：OFF, 自动：AUTO
    setNeedClip: true, // 录制 设置是否需要支持片段录制
    setMaxDuration: 15, // 录制 设置最大录制时长 单位秒
    setMinDuration: 2, // 录制 设置最小录制时长 单位秒
    setVideoQuality: 'HD', // 录制设置视频质量 4个级别, 低：LD ,中：SD ，高：HD ，极高：SSD
    setGop: 125, // 设置关键帧间隔，建议：1-300之间
    setMinVideoDuration: 5, // 裁剪 设置过滤的视频最小长度 单位秒
    setMaxVideoDuration: 15, // 裁剪 设置过滤的视频最大长度 单位秒
    setMinCropDuration: 2,  // 裁剪 设置视频最小裁剪时间 单位毫秒
    setFrameRate: 25, // 裁剪 设置帧率
    setNeedRecord: false, // 设置是否需要开放录制入口,即选择视频的页面，多出一个录制按钮
    setResulutionMode: '540p', // 设置裁剪分辨率，目前支持360p，480p，540p，720p
    setCropMode: 'cpu' // 设置裁剪方式，是否使用gpu进行裁剪，不设置则默认使用cpu来裁剪
  }

  let recordVideo = new RecordVideo(option)

  let recordVideoIos = new RecordVideoIos(option)

  window.plus.compressVideo = compressVideo
  if (plus.os.name === 'Android') {
    window.plus.recordVideo = recordVideo
  } else {
    window.plus.recordVideo = recordVideoIos
  }

  var webview = plus.webview.currentWebview()
  // let isExit = false
  plus.key.addEventListener('backbutton', function () {
    webview.canBack(function (e) {
      if (e.canBack) {
        if (document.getElementById('__MUI_PREVIEWIMAGE').getAttribute('display') !== 'none') {
          document.getElementById('__MUI_PREVIEWIMAGE').setAttribute('display', 'none')
        } else {
          // router.back()
        }
      }
      // else {
      //   if (isExit) {
      //     webview.close()
      //   } else {
      //     isExit = true
      //     plus.nativeUI.toast('<font style="font-size:14px">再按一次返回键退出</font>', {
      //       type: 'richtext',
      //       duration: 'long',
      //       richTextStyle: {align: 'center'}
      //     })
      //     setTimeout(() => {
      //       isExit = false
      //     }, 2000)
      //   }
      // }
    })
  })

  // 热更新
  check()
  checkArguments()
})



// WEBPACK FOOTER //
// ./src/assets/js/plusready.js